import React, { useState, useEffect } from 'react';

const Countdown = () => {
    const calculateTimeLeft = () => {
        const difference = +new Date("2025-12-28T12:05:00") - +new Date();
        let timeLeft = {}; if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        }
        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);
        return () => clearTimeout(timer);
    });

    const timerComponents = [];

    Object.keys(timeLeft).forEach((interval) => {
        timerComponents.push(
            <div key={interval} className="flex flex-col items-center mx-4 md:mx-8 mb-4 md:mb-0">
                <span className="font-serif text-4xl md:text-6xl text-wedding-charcoal tabular-nums">
                    {timeLeft[interval] || '0'}
                </span>
                <span className="text-xs uppercase tracking-widest text-wedding-gray mt-2">
                    {interval}
                </span>
            </div>
        );
    });

    return (
        <section className="py-24 bg-wedding-ivory border-t border-wedding-beige/50">
            <div className="flex justify-center flex-wrap items-center">
                {timerComponents.length ? timerComponents : <span className="font-serif text-4xl">Today is the day!</span>}
            </div>
        </section>
    );
};

export default Countdown;
